import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Empty } from "antd";
import { NotificationManager } from "react-notifications";
import KycQuotationTab from "./KycQuotationTab";
import { fetchQuotationMasterList } from "./kycQuotationShared";

const KycPartnerQuotationTab = ({
	crmGuid,
	customer = "",
	isActive,
	navigationContext = {},
	tableSearchTerm = "",
}) => {
	const [isLoading, setIsLoading] = useState(false);
	const [quotationTable, setQuotationTable] = useState({
		rows: [],
		totalRecords: 0,
		currentPage: 1,
		pageSize: 10,
	});
	const [quotationSorter, setQuotationSorter] = useState({
		field: "createdOn",
		order: "DESC",
	});

	const loadQuotationList = useCallback(async () => {
		if (!crmGuid || !customer) {
			setQuotationTable((prev) => ({ ...prev, rows: [], totalRecords: 0 }));
			return;
		}

		setIsLoading(true);
		try {
			const result = await fetchQuotationMasterList({
				customer,
				crmGuid,
				pageindex: quotationTable.currentPage,
				pagesize: quotationTable.pageSize,
				sortcolumn: quotationSorter.field,
				orderBy: quotationSorter.order,
				groupCompanyId: navigationContext.groupCompanyId || "",
			});

			setQuotationTable((prev) => ({
				...prev,
				rows: result.rows,
				totalRecords: result.totalRecords,
				currentPage: result.currentPage,
			}));
		} catch (error) {
			console.log(error, "Error");
			NotificationManager.error("Unable to load quotation listing.");
			setQuotationTable((prev) => ({ ...prev, rows: [], totalRecords: 0 }));
		} finally {
			setIsLoading(false);
		}
	}, [
		crmGuid,
		customer,
		quotationTable.currentPage,
		quotationTable.pageSize,
		quotationSorter.field,
		quotationSorter.order,
		navigationContext.groupCompanyId,
	]);

	useEffect(() => {
		if (!isActive || !crmGuid) {
			return undefined;
		}
		loadQuotationList();
		return undefined;
	}, [isActive, crmGuid, loadQuotationList]);

	const handleQuotationTableChange = ({ currentPage, sortColumn, orderBy, pageSize }) => {
		setQuotationTable((prev) => ({
			...prev,
			currentPage,
			pageSize: pageSize || prev.pageSize,
		}));
		setQuotationSorter((prev) => ({
			field: sortColumn ?? prev.field,
			order: orderBy ?? prev.order,
		}));
	};

	const emptyText = <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="No data" />;

	const partnerDetailsContext = useMemo(
		() => ({
			crmGuid,
			customer,
			groupCompanyId: navigationContext.groupCompanyId || "",
			groupCompanyName: navigationContext.groupCompanyName || "",
			accountName: navigationContext.accountName || "",
			materialsCustomer: navigationContext.materialsCustomer || "",
			returnTab: navigationContext.returnTab || "account",
		}),
		[crmGuid, customer, navigationContext]
	);

	return (
		<KycQuotationTab
			tabTableData={quotationTable}
			isLoading={isLoading}
			tableSorter={quotationSorter}
			OnhandleTableSortColumn={handleQuotationTableChange}
			navigationContext={navigationContext}
			partnerDetailsContext={partnerDetailsContext}
			emptyText={emptyText}
			tableSearchTerm={tableSearchTerm}
		/>
	);
};

export default KycPartnerQuotationTab;
